import React, { useState, useEffect } from "react";
import { Redirect } from "react-router-dom";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { InputLoginV2 } from "../../components/input/Input";
import { InputGroupLoginV2 } from "../../components/inputGroup/InputGroup";
import { postLoginUser } from "../../redux/slices/loginSlice";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import Base64 from "../../utils/base64";
import { isMobile } from "react-device-detect";
import { Icon, Button } from "antd";
import { ToolTipCreator } from "../../helpers/ToolTipCreator";
import { MobileResponsiveModal } from "./MobileResponsiveModal";
import "./Login.css";

function LoginV2() {
  const userLoginToken = localStorage.getItem("userLoginToken");
  const location = useLocation();

  const [token] = useState(userLoginToken);
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showMobileModal, setShowMobileModal] = useState(false);

  const assetPlanetClientName = "asset_planet_resource";
  const assetPlanetClientPassword = "a_p_creds";
  const basicCreds = Base64.btoa(
    assetPlanetClientName + ":" + assetPlanetClientPassword
  );

  const config = {
    headers: {
      "Content-type": "Application/json",
      Authorization: "Basic " + basicCreds,
    },
  };

  const user = useSelector((state) => state.rootReducer.loginUser);
  const dispatch = useDispatch();

  const [userData, setUserData] = useState({});

  const history = useHistory();
  useEffect(() => {
    if (isMobile) {
      setShowMobileModal(true); // show the modal when mobile is detected
    }
  }, []);

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      if (
        userData.hasOwnProperty("userName") ||
        userData.hasOwnProperty("password")
      ) {
        delete userData.phone;
      }
      dispatch(postLoginUser(userData, config, history, location, setLoading));
    }
  };

  const handleLogin = async () => {
    if (
      userData.hasOwnProperty("userName") ||
      userData.hasOwnProperty("password")
    ) {
      delete userData.phone;
    }
    dispatch(postLoginUser(userData, config, history, location, setLoading));
  };

  return token ? (
    <Redirect
      to={
        location.state && location.state.from
          ? location.state.from.pathname
          : "/dashboard"
      }
    />
  ) : (
    <div className="login-card-main" style={{ marginTop: "20px" }}>
      <style>
        {`
          @keyframes loginButtonSpinner {
            to {
              transform: rotate(360deg);
            }
          }

          @keyframes loginPulseBar {
            0% {
              background-position: 200% 0;
            }
            100% {
              background-position: -200% 0;
            }
          }
        `}
      </style>
      <div className="login-cardV2 border">
        <h2 className="login-headingV2">Log In</h2>
        <div style={{width:"100%"}}>
          <InputGroupLoginV2>
            <label
              className="titleLogin"
              style={{ fontWeight: "500", fontSize: "15px" }}
            >
              Email/Username
            </label>
            <InputLoginV2
              onChange={(e) => {
                setUserData({ ...userData, [e.target.name]: e.target.value });
              }}
              disabled={loading}
              id="username"
              type="text"
              placeholder="Enter your email or username"
              name="username"
            ></InputLoginV2>
          </InputGroupLoginV2>

          <InputGroupLoginV2>
            <label
              className="titleLogin"
              style={{ fontWeight: "500", fontSize: "15px" }}
            >
              Password
            </label>
            <div style={{ position: "relative", width: "100%" }}>
              <InputLoginV2
                onChange={(e) => {
                  setUserData({ ...userData, [e.target.name]: e.target.value });
                }}
                onKeyPress={handleKeyPress}
                disabled={loading}
                id="password"
                type={showPassword ? "text" : "password"}
                placeholder="Password"
                name="password"
                style={{ paddingRight: "40px" }}
              />

              <Icon
                type={showPassword ? "eye-invisible" : "eye"}
                style={{
                  position: "absolute",
                  right: "10px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  fontSize: "18px",
                  cursor: "pointer",
                  color: "#C1C1C7",
                }}
                onClick={() => setShowPassword(!showPassword)}
              />
            </div>
          </InputGroupLoginV2>
          <span
            // href="/sign-up"
            style={{
              color: "#2A3DA3",
              cursor: "pointer",
              float: "right",
              marginBottom: "10px",
              marginTop: "10px",
              fontWeight: "500",
              fontSize: "16px",
              fontFamily: "Poppins",
            }}
            onClick={() => {
              history.push("/forget-password");
            }}
          >
            Forgot Password?
          </span>

          <Button
            className={`login-button ${user.loading || loading ? "login-button-loading" : ""}`}
            onClick={() => {
              handleLogin();
            }}
            disabled={user.loading || loading}
          >
            {loading && (
               <span className="login-button-spinner" />
            )}
            {loading ? "Signing in..." : "Login"}
          </Button>

          <div className="horizontalLine"></div>

          <div
            style={{
              marginTop: "1rem",
              display: "flex",
              // justifyContent: "center",
            }}
          >
            <InputGroupLoginV2>
              <label className="stylesLogin" style={{ color: "#747474" }}>
                Don't have an account?{" "}
                <span style={{ color: "rgb(57, 181, 74" }}>
                  <span
                    style={{
                      color: "#2A3DA3",
                      cursor: "pointer",
                      fontWeight: "500",
                    }}
                    onClick={() => {
                      if (location.state && location.state.from) {
                        history.push({
                          pathname: "/sign-up",
                          state: { from: location.state.from },
                          PathExact: location.PathExact,
                        });
                      } else {
                        history.push("/sign-up");
                      }
                    }}
                  >
                    Sign up
                  </span>
                </span>
              </label>
              <label
                className="stylesLogin"
                style={{ color: "#747474", display: "flex" }}
              >
                Are You Trusted Individual{" "}
                <ToolTipCreator name="Trustee_Login" />
                <span style={{ color: "rgb(57, 181, 74" }}>
                  <a
                    href="/trusteeLogin"
                    style={{ color: "#2A3DA3", fontWeight: "500" }}
                  >
                    Login here
                  </a>
                </span>
              </label>
            </InputGroupLoginV2>
          </div>
          <div className="horizontalLine"></div>

          <div className="problemTextV2">Problem logging in? </div>
          <div className="problemTextV2">
            Contact{" "}
            <span style={{ color: "rgb(57, 181, 74" }}>
              <a
                style={{ color: "#2a3da3", fontWeight: "500" }}
                href="mailto:support@assetplanet.com"
              >
                support@assetplanet.com
              </a>
            </span>
          </div>
        </div>
      </div>
      <MobileResponsiveModal
        showMobileModal={showMobileModal}
        setShowMobileModal={setShowMobileModal}
      />
    </div>
  );
}

export default LoginV2;
